import {
  FIRST_PAGE_BODY_HEIGHT,
  MAX_PAGE_INDEX_TO_SHOW_MAIN_HEADER,
  PAGE_BODY_HEIGHT,
  PAGE_BODY_HEIGHT_WITHOUT_HEADING,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";
import { useStyles } from "@pages/platform-analysis/components/buttons/export-pdf/styles";
import { View } from "@react-pdf/renderer";
import { defaultTo } from "lodash";
import React from "react";

interface PDFPageBodyProps {
  children?: React.ReactNode;
  isFirstPage?: boolean;
  pageIndex?: number;
  shouldRemoveHeading?: boolean;
}

export const PDFPageBody = ({
  children,
  isFirstPage,
  pageIndex,
  shouldRemoveHeading = defaultTo(pageIndex, 0) >
    MAX_PAGE_INDEX_TO_SHOW_MAIN_HEADER,
}: PDFPageBodyProps) => {
  const { pageStyle } = useStyles();

  return (
    <View
      style={
        isFirstPage
          ? { ...pageStyle.body, height: FIRST_PAGE_BODY_HEIGHT }
          : {
              ...pageStyle.body,
              height: shouldRemoveHeading
                ? PAGE_BODY_HEIGHT_WITHOUT_HEADING
                : PAGE_BODY_HEIGHT,
            }
      }
    >
      {children}
    </View>
  );
};
